import React from 'react';

const HomePage = () => {
    return <div></div>
};

export default HomePage;